var render, staticRenderFns
import script from "./FocusAssistant.vue?vue&type=script&lang=js"
export * from "./FocusAssistant.vue?vue&type=script&lang=js"
import style0 from "./FocusAssistant.vue?vue&type=style&index=0&id=45dd338c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd338c",
  null
  
)

/* custom blocks */
import block0 from "./FocusAssistant.vue?vue&type=custom&index=0&blockType=span&class=trigger-label"
if (typeof block0 === 'function') block0(component)
import block1 from "./FocusAssistant.vue?vue&type=custom&index=1&blockType=transition&name=drawer"
if (typeof block1 === 'function') block1(component)

export default component.exports